import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute, renderRoute } from "./routeElements";
import { rootRoute } from "./rootRoute";

const dashboardComponent = lazyWithRetry(() => import("@app/routes/dashboard"));
const loginComponent = lazyWithRetry(() => import("@app/routes/auth/Login"));
const googleCallbackComponent = lazyWithRetry(
  () => import("@app/routes/auth/GoogleCallback"),
);
const logoutComponent = lazyWithRetry(() => import("@app/routes/auth/Logout"));
const registerComponent = lazyWithRetry(
  () => import("@app/routes/auth/Register"),
);
const verifyEmailComponent = lazyWithRetry(
  () => import("@app/routes/auth/VerifyEmail"),
);
const signupComponent = lazyWithRetry(() => import("@app/routes/auth/Signup"));
const forgotPasswordComponent = lazyWithRetry(
  () => import("@app/routes/auth/ForgotPassword"),
);
const resetPasswordComponent = lazyWithRetry(
  () => import("@app/routes/auth/ResetPassword"),
);
const notFoundComponent = lazyWithRetry(
  () => import("@app/routes/errors/NotFound"),
);

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => ({
    breadcrumbs: [{ label: "Dashboard" }],
  }),
  component: () => renderProtectedRoute(dashboardComponent),
});

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/dashboard",
  component: () => renderProtectedRoute(dashboardComponent),
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: () => renderRoute(loginComponent),
});

const googleCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/auth/google/callback",
  component: () => renderRoute(googleCallbackComponent),
});

const logoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/logout",
  component: () => renderRoute(logoutComponent),
});

const registerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/register",
  component: () => renderRoute(registerComponent),
});

const signupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/signup",
  component: () => renderRoute(signupComponent),
});

const onboardingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/onboarding",
  component: () => renderRoute(signupComponent),
});

const verifyEmailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/verify-email",
  component: () => renderRoute(verifyEmailComponent),
});

const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/forgot-password",
  component: () => renderRoute(forgotPasswordComponent),
});

const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reset-password",
  component: () => renderRoute(resetPasswordComponent),
});

export const coreAdminRoutes = [
  indexRoute,
  dashboardRoute,
  loginRoute,
  googleCallbackRoute,
  logoutRoute,
  registerRoute,
  signupRoute,
  onboardingRoute,
  verifyEmailRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
];

export const adminNotFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "*",
  component: () => renderRoute(notFoundComponent),
});
